export default "__VITE_ASSET__H1bRcdJs__"